export const version = "networks/5.2.0";
